import { useStore } from 'vuex';
import phone from 'src/mixins/phone.js';

export function useContactField() {

  // centralize the logic for getting a contact field
  const getContactColumn = (contact, field) => {
    if (field.includes('.')) {
      const parts = field.split('.');
      return contact[parts[0]]?.[parts[1]] || '';
    }
    if (field === 'mobile_phone' || field === 'home_phone') {
      return phone.methods.formatPhoneNumber(contact[field]);
    }
    return contact[field] || '';
  };


  return {
    getContactColumn,
  };
}
